<template>
    <div class="update-profile-component" v-if="user">
        <!-- Alerte pour validation d'identité par SMS requise -->
        <div
            class="alert alert-warning sms-validation-alert"
            v-if="smsValidationRequired && !user.identity_validated"
        >
            <div class="alert-icon">
                <i class="fa fa-shield" aria-hidden="true"></i>
            </div>
            <div class="alert-message">
                <strong>{{ $t('validationSMSRequise') }}</strong><br>
                {{ $t('validationSMSRequiseDetail') }}
                <ul class="requirements-list">
                    <li :class="{ completed: user.image && user.image.length > 0 }">
                        <i :class="user.image && user.image.length > 0 ? 'fa fa-check-circle' : 'fa fa-circle-o'"></i>
                        {{ $t('imagenPerfil') }}
                    </li>
                    <li :class="{ completed: user.description && user.description.length > 0 }">
                        <i :class="user.description && user.description.length > 0 ? 'fa fa-check-circle' : 'fa fa-circle-o'"></i>
                        {{ $t('descripcion') }}
                    </li>
                    <li :class="{ completed: user.mobile_phone && user.mobile_phone.length > 0 }">
                        <i :class="user.mobile_phone && user.mobile_phone.length > 0 ? 'fa fa-check-circle' : 'fa fa-circle-o'"></i>
                        {{ $t('numeroTelephone') }}
                    </li>
                </ul>
            </div>
        </div>
        
        <!-- Module de vérification du téléphone -->
        <SmsIdentityValidation 
            v-if="smsRequired && !user.phone_verified_at"
            @verified="onPhoneVerified"
        />
        
        <div
            class="alert alert-info"
            v-if="showProfileAlert && (
                !user.image ||
                user.image.length === 0 ||
                !user.description ||
                user.description.length === 0
            )"
        >
            <div class="alert-icon">
                <i class="fa fa-exclamation" aria-hidden="true"></i>
            </div>
            <div class="alert-message">
                {{ $t('hola') }}
                <strong>{{ user.name }}</strong>
                {{ $t('bienvenidoACarpoolear') }}
                <span
                    v-if="
                        (!user.image || user.image.length === 0) &&
                        (!user.description || user.description.length === 0)
                    "
                >
                    {{ $t('completaTu') }}
                    <strong>{{ $t('imagenPerfil') }}</strong>
                    {{ $t('yTu') }}
                    <strong>{{ $t('descripcion') }}</strong>
                    {{ $t('comenzarViajar') }}
                </span>
                <span
                    v-if="
                        (!user.image || user.image.length === 0) &&
                        !(!user.description || user.description.length === 0)
                    "
                >
                    {{ $t('completaTu') }}
                    <strong>{{ $t('imagenPerfil') }}</strong>
                    {{ $t('comenzarViajar') }}
                </span>
                <span
                    v-if="
                        !(!user.image || user.image.length === 0) &&
                        (!user.description || user.description.length === 0)
                    "
                >
                    {{ $t('completaTu') }}
                    <strong>{{ $t('descripcion') }}</strong>
                    {{ $t('comenzarViajar') }}
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-24 col-sm-16">
                <div class="form">
                    <div class="alert alert-info">
                        {{ $t('incentivoFoto') }}
                    </div>
                    
                    <!-- Ligne 1 : Nom et Email en 2 colonnes -->
                    <div class="row">
                        <div class="col-xs-24 col-md-12">
                            <div class="form-group">
                                <label for="input-name">
                                    {{ $t('nombreYapellido') }}
                                    <span
                                        class="required-field-flag"
                                        :title="$t('tituloCampoRequerido')"
                                        >(*)</span
                                    >
                                </label>
                                <input
                                    maxlength="25"
                                    v-model="user.name"
                                    type="text"
                                    class="form-control"
                                    id="input-name"
                                    :placeholder="$t('placeholderNombre')"
                                    :class="{ 'has-error': nombreError.state }"
                                    :disabled="!firstTime"
                                />
                                <span class="error" v-if="nombreError.state">
                                    {{ nombreError.message }}
                                </span>
                            </div>
                        </div>
                        <div class="col-xs-24 col-md-12">
                            <div class="form-group">
                                <label for="input-email">
                                    {{ $t('email') }}
                                    <span
                                        class="required-field-flag"
                                        :title="$t('tituloCampoRequerido')"
                                        >(*)</span
                                    >
                                </label>
                                <input
                                    maxlength="40"
                                    v-model="user.email"
                                    type="text"
                                    class="form-control"
                                    id="input-email"
                                    :placeholder="$t('eMail')"
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <!--<div class="form-group">
                    <label for="">Fecha de nacimiento <span class="required-field-flag" title="Campo requerido">(*)</span></label>
                    <DatePicker :value="dayjs(birthday).format('YYYY-MM-DD') " ref="ipt_calendar" name="ipt_calendar" :maxDate="maxDate" :minDate="minDate" :class="{'has-error': birthdayError.state}" ></DatePicker>
                    <span class="error" v-if="birthdayError.state"> {{birthdayError.message}} </span>
                </div>-->
                    <div class="form-group bio-field-container">
                        <label for="input-description">
                            {{ $t('acercaDeMi') }}
                            <span
                                class="required-field-flag"
                                :title="$t('tituloCampoRequerido')"
                                >(*)</span
                            >
                        </label>
                        <p class="field-help-text">
                            {{ $t('incentivoDescripcion') }}
                        </p>
                        <div class="textarea-with-ai-container">
                            <textarea
                                maxlength="2000"
                                v-model="user.description"
                                :placeholder="$t('placeholderDescripcion')"
                                :class="{ 'has-error': descError.state }"
                            ></textarea>
                            <button
                                type="button"
                                class="btn-generate-ai"
                                @click="generateBioWithAI"
                                :disabled="loadingAiBio"
                                :title="$t('generateBioWithAI')"
                            >
                                <span v-if="!loadingAiBio">
                                    <i class="fa fa-magic" aria-hidden="true"></i>
                                    {{ $t('generateWithAI') }}
                                </span>
                                <span v-else>
                                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                    {{ $t('generating') }}
                                </span>
                            </button>
                        </div>
                        <span class="error textarea" v-if="descError.state">
                            {{ descError.message }}
                        </span>
                    </div>
                    <hr />
                    <p class="form-group">
                        {{ $t('siSosConductorDatosVisibles') }}
                    </p>
                    
                    <!-- Ligne 2 : Document et Téléphone en 2 colonnes -->
                    <div class="row">
                        <div class="col-xs-24 col-md-12">
                            <div class="form-group">
                                <label for="input-dni">
                                    {{ $t('documento') }}
                                    <span
                                        class="required-field-flag"
                                        :title="$t('tituloCampoRequerido')"
                                        >(*)</span
                                    >
                                </label>
                                <p class="field-help-text">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $t('incentivoDoc') }}
                                </p>
                                <input
                                    type="tel"
                                    v-model="user.nro_doc"
                                    @input="handleDniInput"
                                    class="form-control"
                                    id="input-dni"
                                    :placeholder="config.profile_id_format"
                                    :class="{ 'has-error': dniError.state }"
                                    :maxlength="(config.profile_id_format).length"
                                    :disabled="isDniLockedByValidation"
                                    :title="dniInputTitle"
                                />
                                <span class="error" v-if="dniError.state">
                                    {{ dniError.message }}
                                </span>
                            </div>
                        </div>
                        <div class="col-xs-24 col-md-12">
                            <div class="form-group">
                                <label for="input-telefono">
                                    {{ $t('nroTel') }}
                                    <span
                                        class="required-field-flag"
                                        :title="$t('tituloCampoRequerido')"
                                        >(*)</span
                                    >
                                </label>
                                <p class="field-help-text">
                                    <i class="fa fa-info-circle"></i>
                                    {{ $t('incentivoTelefono') }}
                                </p>
                                <div class="phone-input-container">
                                    <div
                                        class="country-selector-custom"
                                        :class="{ 'has-error': phoneError.state, 'open': countryDropdownOpen }"
                                        @click="countryDropdownOpen = !countryDropdownOpen"
                                        v-click-outside="() => { countryDropdownOpen = false }"
                                    >
                                        <span class="selected-country">
                                            <span class="flag">{{ selectedCountry.flag }}</span>
                                            <span class="dial-code">{{ selectedCountry.dialCode }}</span>
                                            <i class="fa fa-chevron-down arrow-icon"></i>
                                        </span>
                                        <ul class="country-dropdown-list" v-if="countryDropdownOpen">
                                            <li
                                                v-for="country in countries"
                                                :key="country.code"
                                                :class="{ active: country.code === selectedCountryCode }"
                                                @click.stop="selectCountry(country)"
                                            >
                                                <span class="flag">{{ country.flag }}</span>
                                                <span class="country-name">{{ country.name }}</span>
                                                <span class="dial-code">{{ country.dialCode }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <input
                                        maxlength="15"
                                        @keydown="isNumber"
                                        v-on:paste="isNumber"
                                        v-model="phoneNumberLocal"
                                        @input="updatePhoneNumber"
                                        type="tel"
                                        class="form-control phone-number-input"
                                        id="input-telefono"
                                        :placeholder="$t('placeholderTelefono')"
                                        :class="{ 'has-error': phoneError.state }"
                                    />
                                </div>
                                <span class="error" v-if="phoneError.state">
                                    {{ phoneError.message }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="input-patente">
                            {{ $t('patente') }}
                        </label>
                        <p class="field-help-text">
                            <i class="fa fa-info-circle"></i>
                            ({{ $t('soloConductores') }}). {{ $t('incentivoPatente') }}
                        </p>
                        <input
                            maxlength="20"
                            v-model="patente"
                            type="text"
                            class="form-control"
                            id="input-patente"
                            :class="{ 'has-error': patentError.state }"
                        />
                        <span class="error" v-if="patentError.state">
                            {{ patentError.message }}
                        </span>
                    </div>
                    <div class="checkbox">
                        <label>
                            <input
                                type="checkbox"
                                v-model="user.data_visibility"
                                true-value="1"
                                false-value="0"
                            />
                            {{ $t('datosVisiblesCheck') }}
                        </label>
                        <div>
                            {{ $t('tildaOpcionDatosVisibles') }}
                        </div>
                    </div>
                    <hr />
                    <div class="checkbox">
                        <label>
                            <input
                                type="checkbox"
                                v-model="user.emails_notifications"
                            />
                            {{ $t('notificacionesPorCorreo') }}
                        </label>
                    </div>
                    <hr />
                    <div class="checkbox">
                        <label>
                            <input
                                type="checkbox"
                                @change="changeShowPassword"
                            />
                            {{ $t('cambiarPassword') }}
                        </label>
                    </div>
                    <div class="form-group" v-if="showChangePassword">
                        <label for="input-pass">{{
                            $t('ingreseNuevaPassword')
                        }}</label>
                        <input
                            maxlength="40"
                            v-model="pass.password"
                            type="password"
                            autocomplete="new-password"
                            class="form-control"
                            id="input-pass"
                            :placeholder="$t('placeholderContrasena')"
                        />
                        <input
                            maxlength="40"
                            v-model="pass.password_confirmation"
                            type="password"
                            autocomplete="new-password"
                            class="form-control"
                            id="input-pass-confirm"
                            :placeholder="$t('placeholderRepetirContrasena')"
                        />
                    </div>

                    <hr v-if="settings.module_unaswered_message_limit" />
                    <div
                        class="form-group"
                        v-if="settings.module_unaswered_message_limit"
                    >
                        <label for="input-unaswered_messages_limit">
                            {{ $t('unaswered_messages_limit') }}
                            <span class="description">
                                ({{
                                    $t('unaswered_messages_limitDescription')
                                }})
                            </span>
                        </label>
                        <input
                            type="numer"
                            data-max-length="8"
                            v-model="user.unaswered_messages_limit"
                            class="form-control"
                            id="input-unaswered_messages_limit"
                            :class="{
                                'has-error': unaswered_messages_limitError.state
                            }"
                        />
                        <span
                            class="error"
                            v-if="unaswered_messages_limitError.state"
                        >
                            {{ unaswered_messages_limitError.message }}
                        </span>
                    </div>
                    <hr />
                    <div
                        class="checkbox"
                        v-if="
                            settings.module_validated_drivers &&
                            !user.driver_is_verified
                        "
                    >
                        <label>
                            <input
                                type="checkbox"
                                @change="changeBeDriver"
                                v-model="this.showBeDriver"
                            />
                            {{ $t('solicitarSerChofer') }}
                        </label>
                    </div>
                    <div
                        class="form-group"
                        v-if="
                            settings.module_validated_drivers &&
                            showBeDriver &&
                            !user.driver_is_verified
                        "
                    >
                        <label for="driver_documentation">{{
                            $t('ingreseDocumentacion')
                        }}</label>
                        <input
                            type="file"
                            id="driver_documentation"
                            multiple
                            @change="onDriverDocumentChange"
                        />
                        <p class="help-block">
                            {{ $t('seRequiereDocumentacion') }}
                        </p>
                    </div>
                    <div v-if="user.driver_is_verified">
                        <i
                            class="fa fa-check-circle check-driver-verified"
                            aria-hidden="true"
                        ></i>
                        <strong>{{ $t('choferVerificado') }}</strong>
                    </div>
                    <div
                        v-if="
                            user.driver_is_verified ||
                            (settings.module_validated_drivers && showBeDriver)
                        "
                    >
                        <!-- Ligne 3 : Type de compte et Banque en 2 colonnes -->
                        <div class="row">
                            <div class="col-xs-24 col-md-12">
                                <div class="form-group">
                                    <label for="tipoDeCuenta">
                                        {{ $t('tipoDeCuenta') }}
                                        <span
                                            class="required-field-flag"
                                            :title="$t('tituloCampoRequerido')"
                                            >(*)</span
                                        >
                                    </label>
                                    <select
                                        v-model="user.account_type"
                                        id="tipoDeCuenta"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="option in accountTypes"
                                            v-bind:value="option.id"
                                        >
                                            {{ option.name }}
                                        </option>
                                    </select>
                                    <span class="error" v-if="accountTypeError.state">
                                        {{ accountTypeError.message }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-xs-24 col-md-12">
                                <div class="form-group">
                                    <label for="bancoDeCuenta">
                                        {{ $t('bancoDeCuenta') }}
                                        <span
                                            class="required-field-flag"
                                            :title="$t('tituloCampoRequerido')"
                                            >(*)</span
                                        >
                                    </label>
                                    <select
                                        v-model="user.account_bank"
                                        id=""
                                        class="form-control"
                                    >
                                        <option
                                            v-for="option in banks"
                                            v-bind:value="option.id"
                                        >
                                            {{ option.name }}
                                        </option>
                                    </select>
                                    <span class="error" v-if="accountBankError.state">
                                        {{ accountBankError.message }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="accountNumber">
                                {{ $t('numeroDeCuenta') }}
                                <span
                                    class="required-field-flag"
                                    :title="$t('tituloCampoRequerido')"
                                    >(*)</span
                                >
                            </label>
                            <input
                                v-model="user.account_number"
                                type="text"
                                class="form-control"
                                id="accountNumber"
                                :placeholder="$t('numeroDeCuenta')"
                            />
                            <span class="error" v-if="accountNumberError.state">
                                {{ accountNumberError.message }}
                            </span>
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="
                            Array.isArray(user.driver_data_docs) &&
                            user.driver_data_docs.length
                        "
                    >
                        <div
                            v-imgSrc:docs="img"
                            v-for="img in user.driver_data_docs"
                            class="img-doc col-md-8 col-sm-12"
                        ></div>
                    </div>

                    <div class="btn-container">
                        <button
                            class="btn btn-primary btn-donar-header"
                            @click="grabar"
                            :disabled="loading"
                        >
                            <span v-if="!loading">{{
                                $t('guardarCambios')
                            }}</span>
                            <spinner class="blue" v-if="loading"></spinner>
                        </button>
                        <span
                            class="required-field-flag"
                            v-bind:class="{ 'required-field-info': isMobile }"
                        >
                            {{ $t('camposObligatorios') }}
                        </span>
                    </div>
                    <hr />
                    <div class="delete-account-container">
                        <button
                            class="btn btn-danger pull-right"
                            @click="toggleModalDeleteAccount"
                        >
                            {{ $t('eliminarCuenta') }}
                        </button>
                    </div>
                    
                    <span v-if="error">{{ error }}</span>
                    <Uploadfile
                        :name="'profile'"
                        @change="onPhotoChange"
                        ref="file"
                    ></Uploadfile>
                </div>
            </div>
            <div class="col-xs-24 col-sm-8">
                <div class="profile_image-container">
                    <div
                        class="circle-box"
                        v-imgSrc:profile="user.image"
                        :class="{ loading: loadingImg }"
                    >
                        <div @click="changePhoto" class="profile_image-edit">
                            <svgItem icon="addPhoto" size="28"></svgItem>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal
            :name="'modal-delete-account'"
            v-if="showModalDeleteAccount"
            @close="toggleModalDeleteAccount"
            :body="'Body'"
        >
            <template #header><h3>
                <span>{{ $t('seguroEliminarCuenta') }}</span>
                <i
                    v-on:click="toggleModalDeleteAccount"
                    class="fa fa-times float-right-close"
                ></i>
            </h3></template>
            <template #body><div>
                <div class="text-left color-black" v-if="!showNegativeRatingsInModal">
                    <p>{{ $t('eliminacionCuentaRecuperarCuenta') }}</p>
                    <div class="text-center" style="margin-top: 1em;">
                        <button
                            class="btn btn-default"
                            @click="openMesaAyudaFromDelete"
                        >
                            {{ $t('contactarMesaAyuda') }}
                        </button>
                    </div>
                    <p style="margin-top: 1.5em;">{{ $t('eliminacionCuentaOtroMotivo') }}</p>
                    <div class="text-center" style="margin-top: 1.5em;">
                        <button
                            class="btn btn-danger"
                            @click="deleteAccount"
                            :disabled="loadingDeleteAccount"
                        >
                            <span v-if="!loadingDeleteAccount"
                                >{{ $t('eliminarCuenta') }}</span
                            >
                            <spinner class="blue" v-if="loadingDeleteAccount"></spinner>
                        </button>
                    </div>
                </div>
                <div class="text-left color-black" v-else>
                    <p>{{ $t('eliminacionCuentaNegativas') }}</p>
                    <p>{{ $t('eliminacionCuentaIrreversible') }}</p>
                    <p>{{ $t('eliminacionCuentaPlazo') }}</p>
                    <div class="text-center" style="margin-top: 1.5em;">
                        <button
                            class="btn btn-primary"
                            @click="requestAccountDeletion"
                            :disabled="loadingDeleteAccount"
                        >
                            <span v-if="!loadingDeleteAccount">{{ $t('solicitarEliminacionCuenta') }}</span>
                            <spinner class="blue" v-if="loadingDeleteAccount"></spinner>
                        </button>
                    </div>
                </div>
            </div></template>
        </modal>

        <modal
            name="mesaAyudaModal"
            v-if="showMesaAyudaModal"
            @close="showMesaAyudaModal = false"
        >
            <template #header><h3>
                <span>{{ $t('mesaAyuda') }}</span>
                <i
                    v-on:click="showMesaAyudaModal = false"
                    class="fa fa-times float-right-close"
                ></i>
            </h3></template>
            <template #body><div>
                <div class="text-left color-black login-modal">
                    <p>
                        {{ $t('mesaAyudaFuncionaDesde') }}
                        <a :href="'mailto:' + config.admin_email">
                            {{ config.admin_email }}</a>,
                        {{ $t('mensajePrivadoDe') }}
                        <a href="https://instagram.com/carpoolear">Instagram</a>
                        {{ $t('y') }}
                        <a href="https://facebook.com/carpoolear">Facebook</a>.
                    </p>
                </div>
            </div></template>
        </modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { inputIsNumber, formatId, cleanId } from '../../services/utility';
import Uploadfile from '../Uploadfile';
import DatePicker from '../DatePicker';
import SvgItem from '../SvgItem';
import SmsIdentityValidation from './SmsIdentityValidation.vue';
import dialogs from '../../services/dialogs.js';
import dayjs from '../../dayjs';
import bus from '../../services/bus-event';
import Spinner from '../Spinner.vue';
import modal from '../Modal';
import { UserApi } from '../../services/api';

class Error {
    constructor(state = false, message = '') {
        this.state = false;
        this.message = '';
    }
}

export default {
    name: 'upddate-profile',
    data() {
        return {
            user: null,
            car: null,
            patente: '',
            pass: {
                password: '',
                password_confirmation: ''
            },
            error: null,
            loading: false,
            loadingImg: false,
            globalError: false,
            nombreError: new Error(),
            descError: new Error(),
            birthdayError: new Error(),
            patentError: new Error(),
            dniError: new Error(),
            unaswered_messages_limitError: new Error(),
            phoneError: new Error(),
            emailError: new Error(),
            accountNumberError: new Error(),
            accountTypeError: new Error(),
            accountBankError: new Error(),
            maxDate: dayjs().toDate(),
            minDate: dayjs('1900-01-01').toDate(),
            birthday: '',
            birthdayAnswer: '',
            showChangePassword: false,
            showBeDriver: false,
            driverFiles: null,
            banks: [],
            accountTypes: [],
            showModalDeleteAccount: false,
            loadingDeleteAccount: false,
            showNegativeRatingsInModal: false,
            showMesaAyudaModal: false,
            userApi: null,
            loadingAiBio: false,
            showProfileAlert: true,  // Contrôle manuel de l'alerte
            selectedCountryCode: 'FR',
            phoneNumberLocal: '',
            countryDropdownOpen: false,
            countries: [
                { code: 'FR', name: 'France', dialCode: '+33', flag: '🇫🇷' },
                { code: 'DE', name: 'Allemagne', dialCode: '+49', flag: '🇩🇪' },
                { code: 'BE', name: 'Belgique', dialCode: '+32', flag: '🇧🇪' },
                { code: 'CH', name: 'Suisse', dialCode: '+41', flag: '🇨🇭' },
                { code: 'LU', name: 'Luxembourg', dialCode: '+352', flag: '🇱🇺' },
                { code: 'IT', name: 'Italie', dialCode: '+39', flag: '🇮🇹' },
                { code: 'ES', name: 'Espagne', dialCode: '+34', flag: '🇪🇸' },
                { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
                { code: 'NL', name: 'Pays-Bas', dialCode: '+31', flag: '🇳🇱' },
                { code: 'GB', name: 'Royaume-Uni', dialCode: '+44', flag: '🇬🇧' },
                { code: 'US', name: 'États-Unis', dialCode: '+1', flag: '🇺🇸' },
                { code: 'CA', name: 'Canada', dialCode: '+1', flag: '🇨🇦' }
            ]
        };
    },
    computed: {
        ...mapGetters({
            userData: 'auth/user',
            firstTime: 'auth/firstTime',
            cars: 'cars/cars',
            isMobile: 'device/isMobile',
            settings: 'auth/appConfig',
            config: 'auth/appConfig'
        }),
        selectedCountry() {
            return this.countries.find(c => c.code === this.selectedCountryCode) || this.countries[0];
        },
        iptUser() {
            if (this.user) {
                return this.user.name;
            }
        },
        iptEmail() {
            if (this.user) {
                return this.user.email;
            }
        },
        iptBirthday() {
            if (this.user) {
                return this.user.birthdayAnswer;
            }
        },
        iptDescription() {
            if (this.user) {
                return this.user.description;
            }
        },
        iptDni() {
            if (this.user) {
                return this.user.nro_doc;
            }
        },
        isDniLockedByValidation() {
            return !!(
                this.user &&
                this.user.identity_validated &&
                this.user.identity_validated_at
            );
        },
        dniInputTitle() {
            return this.isDniLockedByValidation
                ? this.$t('dniValidadoContacteSoporte')
                : '';
        },
        smsValidationRequired() {
            return this.config && 
                   this.config.identity_validation_sms_enabled && 
                   this.config.identity_validation_required_new_users &&
                   this.user &&
                   this.user.identity_validation_required_for_user;
        },
        iptPhone() {
            if (this.user) {
                return this.user.mobile_phone;
            }
        }
    },
    methods: {
        dayjs,
        ...mapActions({
            update: 'auth/update',
            updatePhoto: 'auth/updatePhoto',
            carCreate: 'cars/create',
            carUpdate: 'cars/update',
            carIndex: 'cars/index',
            getBankData: 'profile/getBankData'
        }),
        jumpToError() {
            let hasError = document.getElementsByClassName('has-error');
            if (hasError.length) {
                let element = hasError[0];
                this.$scrollToElement(element, -270);
            }
        },
        changeShowPassword() {
            this.showChangePassword = !this.showChangePassword;
        },
        changeBeDriver() {
            this.showBeDriver = !this.showBeDriver;
        },
        isNumber(value) {
            inputIsNumber(value);
        },
        // Callback when phone verification is completed
        onPhoneVerified() {
            console.log('✅ [UpdateProfile] Phone verified! Refreshing user data...');
            // Refresh user data from backend to get updated phone_verified_at
            this.$store.dispatch('auth/refresh').then(() => {
                dialogs.message(this.$t('telefonoYaVerificado'), { 
                    duration: 6, 
                    position: 'top-center', 
                    estado: 'success' 
                });
            }).catch(error => {
                console.error('❌ [UpdateProfile] Error refreshing user data:', error);
            });
        },
        // Handle DNI input - format using pattern
        handleDniInput(event) {
            const formatted = formatId(event.target.value, this.config.profile_id_format);
            event.target.value = formatted;
            // Update the Vue data model with the formatted value
            this.user.nro_doc = formatted;
        },
        // Update phone number with country code
        updatePhoneNumber() {
            const country = this.countries.find(c => c.code === this.selectedCountryCode);
            if (country && this.phoneNumberLocal) {
                const cleanNumber = this.phoneNumberLocal.replace(/\s+/g, '');
                this.user.mobile_phone = country.dialCode + cleanNumber;
            } else if (country) {
                this.user.mobile_phone = country.dialCode;
            }
        },
        selectCountry(country) {
            this.selectedCountryCode = country.code;
            this.countryDropdownOpen = false;
            this.updatePhoneNumber();
        },
        // Parse existing phone number to extract country code and local number
        parseExistingPhone() {
            if (!this.user || !this.user.mobile_phone) return;
            
            const phone = this.user.mobile_phone;
            // Find matching country by dial code
            for (const country of this.countries) {
                if (phone.startsWith(country.dialCode)) {
                    this.selectedCountryCode = country.code;
                    this.phoneNumberLocal = phone.substring(country.dialCode.length);
                    return;
                }
            }
            
            // If no match found, try to detect if it starts with +
            if (phone.startsWith('+')) {
                // Default to France if not recognized
                this.selectedCountryCode = 'FR';
                this.phoneNumberLocal = phone;
            } else {
                // Assume it's a French number without country code
                this.selectedCountryCode = 'FR';
                this.phoneNumberLocal = phone;
            }
        },
        onPhotoChange(data) {
            this.loadingImg = true;
            this.updatePhoto(data)
                .then((user) => {
                    this.user.image = user.image;
                    this.loadingImg = false;
                })
                .catch(() => {
                    this.loadingImg = false;
                });
        },
        onDriverDocumentChange(event) {
            if (event.target.files) {
                this.driverFiles = event.target.files;
            }
        },
        dateChange(value) {
            this.birthdayAnswer = value;
        },
        changePhoto() {
            this.$refs.file.show();
        },
        grabar() {
            console.log('🔵 [DEBUT] Méthode grabar() appelée');
            console.log('📋 [DATA] User actuel:', JSON.parse(JSON.stringify(this.user)));
            console.log('📋 [DATA] SMS required:', this.smsValidationRequired);
            console.log('📋 [DATA] Phone verified:', this.user ? this.user.phone_verified : 'N/A');
            
            if (this.validate()) {
                console.log('❌ [VALIDATION] Échec de validation - champs manquants');
                this.$nextTick(() => {
                    this.jumpToError();
                    dialogs.message(this.$t('faltanCamposObligatorios'), {
                        duration: 10,
                        estado: 'error'
                    });
                });
                return;
            }
            
            console.log('✅ [VALIDATION] Validation réussie');
            this.loading = true;
            
            // Ensure user.nro_doc is raw value (no dots) before sending
            if (this.user && this.user.nro_doc) {
                console.log('🔧 [CLEAN] Nettoyage nro_doc:', this.user.nro_doc);
                this.user.nro_doc = cleanId(this.user.nro_doc, this.config.profile_id_format);
            }
            
            // Only send properties the backend allows for profile edit (name/email are read-only)
            const allowedProfileUpdateKeys = [
                'birthday', 'gender', 'description', 'mobile_phone', 'emails_notifications',
                'nro_doc', 'data_visibility',
                'do_not_alert_request_seat', 'do_not_alert_accept_passenger',
                'do_not_alert_pending_rates', 'do_not_alert_pricing',
                'autoaccept_requests', 'unaswered_messages_limit',
                'account_number', 'account_type', 'account_bank'
            ];
            const data = {};
            allowedProfileUpdateKeys.forEach((key) => {
                if (this.user.hasOwnProperty(key) && this.user[key] !== undefined) {
                    data[key] = this.user[key];
                }
            });
            
            console.log('📦 [DATA] Données à envoyer:', JSON.parse(JSON.stringify(data)));
            
            if (this.pass.password) {
                console.log('🔑 [PASSWORD] Changement de mot de passe détecté');
                if (this.pass.password !== this.pass.password_confirmation) {
                    console.log('❌ [PASSWORD] Les mots de passe ne correspondent pas');
                    this.error = this.$t('passwordNoCoincide');
                    return;
                }
                data.password = this.pass.password;
                data.password_confirmation = this.pass.password_confirmation;
            }
            
            /* global FormData */
            let bodyFormData = new FormData();
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    if (Array.isArray(data[key])) {
                        for (let index = 0; index < data[key].length; index++) {
                            const element = data[key][index];
                            bodyFormData.append(key + '[]', element);
                        }
                    } else {
                        if (data[key] !== null && data[key] !== undefined) {
                            bodyFormData.append(key, data[key]);
                        }
                    }
                }
            }
            
            if (this.driverFiles) {
                console.log('📄 [FILES] Fichiers conducteur détectés:', this.driverFiles.length);
                bodyFormData.append('user_be_driver', true);
                for (let index = 0; index < this.driverFiles.length; index++) {
                    const file = this.driverFiles[index];
                    bodyFormData.append('driver_data_docs[]', file);
                }
            }
            
            console.log('🚀 [API] Envoi de la requête update...');
            this.update(bodyFormData)
                .then(() => {
                    console.log('✅ [API] Réponse reçue - succès');
                    console.log('📋 [USER] User après update:', JSON.parse(JSON.stringify(this.user)));
                    
                    this.pass.password = '';
                    this.pass.password_confirmation = '';
                    this.loading = false;
                    
                    // Message de succès personnalisé selon l'état
                    console.log('🔍 [CHECK] smsValidationRequired:', this.smsValidationRequired);
                    console.log('🔍 [CHECK] user.phone_verified:', this.user.phone_verified);
                    
                    if (this.smsValidationRequired && !this.user.phone_verified) {
                        console.log('📱 [SMS] Profil complet mais téléphone non vérifié');
                        // Profil complet mais téléphone non vérifié
                        dialogs.message(this.$t('profilCompletVerifiezTelephone'), {
                            duration: 7,
                            estado: 'success'
                        });
                    } else {
                        console.log('💚 [SUCCESS] Message standard de succès');
                        dialogs.message(this.$t('perfilActualizadoCorrectamente'));
                    }
                    
                    if (this.patente.length) {
                        console.log('🚗 [CAR] Mise à jour de la plaque:', this.patente);
                        if (this.car) {
                            this.car.patente = this.patente;
                            this.carUpdate(this.car);
                        } else {
                            let car = {
                                description: 'NOT USED YET',
                                patente: this.patente
                            };
                            this.carCreate(car);
                        }
                    }
                    
                    // this.user.birthday = this.birthdayAnswer;
                    console.log('🔍 [CHECK] Image:', this.user.image ? 'OK' : 'MANQUANTE');
                    console.log('🔍 [CHECK] Description:', this.user.description ? 'OK' : 'MANQUANTE');
                    
                    // Redirection après mise à jour réussie
                    if (
                        this.user.image &&
                        this.user.image.length > 0 &&
                        this.user.description &&
                        this.user.description.length > 0
                    ) {
                        console.log('✅ [PROFILE] Profil complet détecté');
                        // Profil complet! Vérifier si téléphone vérifié
                        if (this.smsValidationRequired && !this.user.phone_verified) {
                            console.log('🔀 [REDIRECT] Redirection vers validation SMS dans 3 secondes...');
                            // Redirection automatique vers validation d'identité (vérification téléphone)
                            setTimeout(() => {
                                console.log('🔀 [REDIRECT] Exécution de la redirection vers identity_validation');
                                this.$router.push({ name: 'identity_validation' });
                            }, 3000);
                        } else {
                            console.log('🔀 [REDIRECT] Redirection vers /trips dans 2 secondes...');
                            setTimeout(() => {
                                console.log('🔀 [REDIRECT] Exécution de la redirection vers trips');
                                this.$router.push({ name: 'trips' });
                            }, 2000);
                        }
                    } else {
                        console.log('⚠️ [PROFILE] Profil incomplet');
                        if (!(this.user.image && this.user.image.length > 0)) {
                            console.log('❌ [IMAGE] Image de profil manquante');
                            dialogs.message(this.$t('debesImagenPerfil'), {
                                duration: 10,
                                estado: 'error'
                            });
                        } else {
                            // Si le profil est incomplet mais qu'on a quand même sauvegardé, rediriger vers /trips
                            console.log('🔀 [REDIRECT] Profil incomplet mais sauvegardé, redirection vers /trips dans 2 secondes...');
                            setTimeout(() => {
                                console.log('🔀 [REDIRECT] Exécution de la redirection vers trips');
                                this.$router.push({ name: 'trips' });
                            }, 2000);
                        }
                    }
                })
                .catch((err) => {
                    console.error('❌ [API] Erreur lors de la requête update');
                    console.error('📋 [ERROR] Détails de l\'erreur:', err);
                    console.error('📋 [ERROR] err.response:', err.response);
                    console.error('📋 [ERROR] err.data:', err.data);
                    console.error('📋 [ERROR] err.errors:', err.errors);
                    
                    console.error(err);
                    this.loading = false;
                    
                    // Check if DNI is already taken
                    const isDocTaken =
                        err &&
                        err.errors &&
                        err.errors.nro_doc &&
                        Array.isArray(err.errors.nro_doc) &&
                        err.errors.nro_doc.length > 0;
                    
                    // Check if phone is already taken
                    const isPhoneTaken =
                        err &&
                        err.errors &&
                        err.errors.mobile_phone &&
                        Array.isArray(err.errors.mobile_phone) &&
                        err.errors.mobile_phone.length > 0;
                    
                    console.log('🔍 [VALIDATION] isDocTaken:', isDocTaken);
                    console.log('🔍 [VALIDATION] isPhoneTaken:', isPhoneTaken);
                    
                    // Show specific toast notification for DNI conflict
                    if (isDocTaken) {
                        console.log('🚨 [TOAST] DNI déjà utilisé');
                        dialogs.message(this.$t('nroDocYaRegistrado'), {
                            duration: 6,
                            position: 'top-center',
                            estado: 'error'
                        });
                        this.dniError.state = true;
                        this.dniError.message = this.$t('nroDocYaRegistrado');
                        this.jumpToError();
                        return;
                    }
                    
                    // Show specific toast notification for phone conflict
                    if (isPhoneTaken) {
                        console.log('🚨 [TOAST] Téléphone déjà utilisé');
                        dialogs.message(this.$t('nroTelYaRegistrado'), {
                            duration: 6,
                            position: 'top-center',
                            estado: 'error'
                        });
                        this.phoneError.state = true;
                        this.phoneError.message = this.$t('nroTelYaRegistrado');
                        this.jumpToError();
                        return;
                    }
                    
                    // Check if DNI is banned
                    const isBannedDni =
                        err &&
                        err.errors &&
                        err.errors.error === 'banned_dni';
                    if (isBannedDni) {
                        console.log('🚨 [TOAST] DNI banni');
                        dialogs.message(this.$t('errorAlGuardarContactarMesaAyuda'), {
                            duration: 6,
                            position: 'top-center',
                            estado: 'error'
                        });
                        return;
                    }
                    
                    // Generic error
                    this.error = this.$t('errorDatos');
                    dialogs.message(this.$t('errorDatos'), {
                        duration: 4,
                        position: 'top-center',
                        estado: 'error'
                    });
                    this.jumpToError();
                });
        },
        validate() {
            console.log('🔍 [VALIDATION] Début de la validation');
            let globalError = false;
            
            // Reset errors
            this.nombreError.state = false;
            this.descError.state = false;
            this.dniError.state = false;
            this.phoneError.state = false;
            this.patentError.state = false;
            this.accountNumberError.state = false;
            this.accountTypeError.state = false;
            this.accountBankError.state = false;

            if (!this.user.name || this.user.name.length < 1) {
                console.log('❌ [VALIDATION] Nom manquant');
                this.nombreError.state = true;
                this.nombreError.message = this.$t('olvidasteNombre');
                globalError = true;
            } else {
                console.log('✅ [VALIDATION] Nom OK:', this.user.name);
            }

            /* console.log(this.birthdayAnswer);
            if (!this.birthdayAnswer || this.birthdayAnswer.length < 1) {
                this.birthdayError.state = true;
                this.birthdayError.message = this.$t('olvidasteFechaNacimiento');
                globalError = true;
            } else {
                let birthday = dayjs(this.birthdayAnswer);
                if (dayjs().diff(birthday, 'years') < 18) {
                    this.birthdayError.state = true;
                    this.birthdayError.message = this.$t('debesSerMayorDeEdad');
                    globalError = true;
                }
            } */

            // Patente validation removed - now allows all strings
            // Only basic length validation is handled by the input maxlength attribute

            if (!this.user.description || this.user.description.length < 1) {
                console.log('❌ [VALIDATION] Description manquante');
                this.descError.state = true;
                this.descError.message = this.$t('olvidasteDescripcion');
                globalError = true;
            } else if (this.user.description.replace(' ', '').length < 10) {
                console.log('❌ [VALIDATION] Description trop courte:', this.user.description.length, 'caractères');
                this.descError.state = true;
                this.descError.message = this.$t('descripcionCorta');
                globalError = true;
            } else {
                console.log('✅ [VALIDATION] Description OK:', this.user.description.substring(0, 50) + '...');
            }

            // Get raw DNI value (strip any dots that might be present)
            const dniRaw = this.user && this.user.nro_doc
                ? cleanId(this.user.nro_doc, this.config.profile_id_format)
                : '';
            
            if (!dniRaw || dniRaw.length < 1) {
                console.log('❌ [VALIDATION] DNI manquant');
                this.dniError.state = true;
                this.dniError.message = this.$t('olvidasteDni');
                globalError = true;
            } else if (dniRaw.length > 0 && dniRaw.length < 7) {
                console.log('❌ [VALIDATION] DNI trop court:', dniRaw.length, 'caractères');
                this.dniError.state = true;
                this.dniError.message = this.$t('dniNoValido');
                globalError = true;
            } else {
                console.log('✅ [VALIDATION] DNI OK:', dniRaw);
            }

            if (!this.user.mobile_phone || this.user.mobile_phone.length < 1) {
                console.log('❌ [VALIDATION] Téléphone manquant');
                this.phoneError.state = true;
                this.phoneError.message = this.$t('olvidasteTel');
                globalError = true;
            } else if (
                this.user.mobile_phone &&
                this.user.mobile_phone.length > 0 &&
                this.user.mobile_phone.length < 6
            ) {
                console.log('❌ [VALIDATION] Téléphone trop court:', this.user.mobile_phone.length, 'caractères');
                this.phoneError.state = true;
                this.phoneError.message = this.$t('telefonoNoValido');
                globalError = true;
            } else {
                console.log('✅ [VALIDATION] Téléphone OK:', this.user.mobile_phone);
            }

            if (
                this.user.driver_is_verified ||
                (this.settings.module_validated_drivers && this.showBeDriver)
            ) {
                console.log('🚗 [VALIDATION] Validation conducteur activée');
                if (!this.user.account_number) {
                    console.log('❌ [VALIDATION] Numéro de compte manquant');
                    this.accountNumberError.state = true;
                    this.accountNumberError.message =
                        this.$t('campoObligatorio');
                    globalError = true;
                }
                if (!this.user.account_type) {
                    console.log('❌ [VALIDATION] Type de compte manquant');
                    this.accountTypeError.state = true;
                    this.accountTypeError.message = this.$t('campoObligatorio');
                    globalError = true;
                }
                if (!this.user.account_bank) {
                    console.log('❌ [VALIDATION] Banque manquante');
                    this.accountBankError.state = true;
                    this.accountBankError.message = this.$t('campoObligatorio');
                    globalError = true;
                }
            }
            
            console.log('🔍 [VALIDATION] Résultat final - Erreurs:', globalError);
            return globalError;

            return globalError;
        },
        toggleModalDeleteAccount() {
            this.showModalDeleteAccount = !this.showModalDeleteAccount;
            this.showNegativeRatingsInModal = false;
        },
        openMesaAyudaFromDelete() {
            this.showModalDeleteAccount = false;
            this.showMesaAyudaModal = true;
        },
        deleteAccount() {
            this.loadingDeleteAccount = true;
            this.userApi
                .deleteAccount()
                .then((response) => {
                    this.loadingDeleteAccount = false;
                    this.showModalDeleteAccount = false;
                    const action = response && response.action;
                    const message = action === 'deleted'
                        ? this.$t('usuarioEliminadoExitosamente')
                        : action === 'anonymized'
                            ? this.$t('usuarioAnonimizadoExitosamente')
                            : (response && response.message) || this.$t('pedidoEliminacionEnviado');
                    dialogs.message(message, {
                        duration: 5,
                        estado: 'success'
                    });
                    window.location.href = this.$router.resolve({ name: 'trips' }).href;
                })
                .catch((error) => {
                    this.loadingDeleteAccount = false;
                    if (error.data && error.data.error === 'negative_ratings') {
                        this.showNegativeRatingsInModal = true;
                    } else {
                        const message = (error.data && error.data.message) || this.$t('errorEnviarPedidoEliminacion');
                        dialogs.message(message, {
                            duration: 5,
                            estado: 'error'
                        });
                    }
                });
        },
        requestAccountDeletion() {
            this.loadingDeleteAccount = true;
            this.userApi
                .deleteAccountRequest()
                .then(() => {
                    this.loadingDeleteAccount = false;
                    this.showModalDeleteAccount = false;
                    this.showNegativeRatingsInModal = false;
                    dialogs.message(this.$t('pedidoEliminacionEnviado'), {
                        duration: 5,
                        estado: 'success'
                    });
                })
                .catch(() => {
                    this.loadingDeleteAccount = false;
                    dialogs.message(this.$t('errorEnviarPedidoEliminacion'), {
                        duration: 5,
                        estado: 'error'
                    });
                });
        },
        async generateBioWithAI() {
            if (this.loadingAiBio) {
                return;
            }

            this.loadingAiBio = true;

            try {
                const response = await this.userApi.generateBio();
                
                if (response && response.bio) {
                    this.user.description = response.bio;
                }
            } catch (error) {
                console.error('Error generating bio:', error);
            } finally {
                this.loadingAiBio = false;
            }
        }
    },
    watch: {
        cars: function () {
            console.log('cars', this.cars);
            if (this.cars.length > 0) {
                this.car = this.cars[0];
                this.patente = this.car.patente;
            }
        },
        userData: function () {
            console.log('userData', this.userData);
            this.user = this.userData;
            // Format nro_doc with pattern when loaded from backend
            if (this.user && this.user.nro_doc) {
                this.user.nro_doc = formatId(this.user.nro_doc, this.config.profile_id_format);
            }
            // Parse phone number to extract country code and local number
            this.parseExistingPhone();
        },
        iptUser() {
            this.nombreError.state = false;
        },
        iptEmail() {
            this.emailError.state = false;
        },
        birthdayAnswer: function () {
            this.birthdayError.state = false;
        },
        iptDescription() {
            this.descError.state = false;
        },
        iptDni() {
            this.dniError.state = false;
        },
        iptPhone() {
            this.phoneError.state = false;
        },
        patente() {
            this.patentError.state = false;
        },
        selectedCountryCode() {
            // Update full phone number when country changes
            this.updatePhoneNumber();
        }
    },

    mounted() {
        this.userApi = new UserApi();
        console.log('touter', this.$router);
        this.getBankData().then((data) => {
            console.log('get bank data', data);
            this.banks = data.banks;
            this.accountTypes = data.cc;
        });
        
        // Load user's cars to populate patente field
        this.carIndex().then(() => {
            console.log('Cars loaded for profile update');
            // Ensure patente is set if cars are loaded
            if (this.cars && this.cars.length > 0) {
                this.car = this.cars[0];
                this.patente = this.car.patente;
                console.log('Patente set from loaded car:', this.patente);
            }
        }).catch((error) => {
            console.error('Failed to load cars:', error);
        });
        bus.on('date-change', this.dateChange);
        this.user = this.userData;
        // Format nro_doc with pattern when page loads
        if (this.user && this.user.nro_doc) {
            this.user.nro_doc = formatId(this.user.nro_doc, this.config.profile_id_format);
        }
        console.log('USUARIO', this.userData);
        if (
            Array.isArray(this.user.driver_data_docs) &&
            this.user.driver_data_docs.length
        ) {
            this.showBeDriver = true;
        }
        if (this.cars) {
            if (this.cars.length > 0) {
                this.car = this.cars[0];
                this.patente = this.car.patente;
            }
        }
        try {
            if (dayjs(this.user.birthday, 'YYYY-MM-DD').isValid()) {
                this.birthday = dayjs(this.user.birthday, 'YYYY-MM-DD');
            } else {
                this.birthday = '';
            }
        } catch (ex) {
            console.log('exception', ex);
        }
    },
    beforeDestroy() {
        bus.off('date-change', this.dateChange);
    },
    directives: {
        'click-outside': {
            bind(el, binding) {
                el._clickOutsideHandler = function(event) {
                    if (!el.contains(event.target)) {
                        binding.value(event);
                    }
                };
                document.addEventListener('click', el._clickOutsideHandler);
            },
            unbind(el) {
                document.removeEventListener('click', el._clickOutsideHandler);
            }
        }
    },
    components: {
        DatePicker,
        Uploadfile,
        SvgItem,
        Spinner,
        modal,
        SmsIdentityValidation
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.update-profile-component .row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -12px;
    margin-right: -12px;
}

.update-profile-component .row > [class*="col-"] {
    padding-left: 12px;
    padding-right: 12px;
}

.profile_image-container {
    text-align: center;
    position: sticky;
    top: 80px;
    padding: 20px 0;
}

@media only screen and (max-width: 767px) {
    .profile_image-container {
        position: static;
        margin-bottom: 20px;
    }
}

.delete-account-container {
    display: flex;
    justify-content: flex-end;
}
.required-field-flag {
    color: red;
}
.required-field-info {
    display: block;
    padding: 1em 0;
}
.profile_image-container.error .circle-box {
    border: solid 2px red;
}
.profile_image-container.error .span {
    color: red;
}
span.error {
    display: block;
    font-size: 12px;
    margin-top: -5px;
    font-weight: bold;
    color: red;
}
span.error.textarea {
    margin-top: 0.8em;
}
@media only screen and (min-width: 768px) {
    span.error {
        font-weight: 300;
    }
}
.img-doc {
    height: 320px;
    background-size: cover;
}
.check-driver-verified {
    font-size: 24px;
    vertical-align: -2px;
    margin-right: 5px;
    color: var(--trip-mostly-free-color);
}

hr {
    border-top: 1px solid #cccccc;
}

/* Styles pour l'alerte de bienvenue */
.update-profile-component > .alert {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;
    gap: 15px;
    padding: 15px 20px;
    box-sizing: border-box;
}

.update-profile-component > .alert .alert-icon {
    flex-shrink: 0;
    font-size: 24px;
    margin-top: 2px;
}

.update-profile-component > .alert .alert-message {
    flex: 1;
    min-width: 0;
    word-wrap: break-word;
}

/* Styles pour les textes d'aide des champs */
.field-help-text {
    font-size: 14px;
    color: #0c5460;
    margin: 8px 0 12px 0;
    line-height: 1.5;
    font-style: italic;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background-color: #d1ecf1;
    padding: 12px 15px;
    border-radius: 6px;
    border: 1px solid #bee5eb;
}

.field-help-text i.fa-info-circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background-color: #0c5460;
    color: #d1ecf1;
    border-radius: 50%;
    font-size: 12px;
    flex-shrink: 0;
    margin-top: 2px;
}

/* Styles pour le champ téléphone avec sélecteur de pays */
.phone-input-container {
    display: flex;
    gap: 10px;
    align-items: stretch;
}

/* Dropdown custom pour les pays */
.country-selector-custom {
    position: relative;
    flex: 0 0 140px;
    min-width: 140px;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    user-select: none;
    box-sizing: border-box;
}

.country-selector-custom:hover,
.country-selector-custom.open {
    border-color: #66afe9;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
}

.country-selector-custom.has-error {
    border-color: red;
}

.selected-country {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 10px;
    gap: 6px;
}

.selected-country .flag {
    font-size: 20px;
    line-height: 1;
}

.selected-country .dial-code {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    flex: 1;
}

.selected-country .arrow-icon {
    font-size: 10px;
    color: #888;
    transition: transform 0.2s ease;
}

.country-selector-custom.open .arrow-icon {
    transform: rotate(180deg);
}

.country-dropdown-list {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 9999;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    min-width: 250px;
    max-height: 280px;
    overflow-y: auto;
    list-style: none;
    margin: 0;
    padding: 4px 0;
}

.country-dropdown-list li {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 14px;
    cursor: pointer;
    transition: background 0.15s ease;
    font-size: 14px;
}

.country-dropdown-list li:hover {
    background-color: #f0f8ff;
}

.country-dropdown-list li.active {
    background-color: #d1ecf1;
    font-weight: 600;
}

.country-dropdown-list .flag {
    font-size: 22px;
    line-height: 1;
    flex-shrink: 0;
}

.country-dropdown-list .country-name {
    flex: 1;
    color: #333;
}

.country-dropdown-list .dial-code {
    color: #666;
    font-size: 13px;
}

.phone-number-input {
    flex: 1;
    min-width: 0;
    height: 40px !important;
    padding: 10px 12px !important;
    border: 1px solid #ddd !important;
    border-radius: 4px !important;
    font-size: 15px;
    box-sizing: border-box;
}

.phone-number-input:focus {
    outline: none;
    border-color: #66afe9 !important;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
}

.phone-number-input.has-error {
    border-color: red !important;
}

@media only screen and (max-width: 767px) {
    .phone-input-container {
        flex-direction: column;
    }

    .country-selector-custom {
        flex: 1;
        width: 100%;
    }

    .country-dropdown-list {
        min-width: 100%;
    }
}

/* Styles pour le champ "À propos de moi" avec IA */
.bio-field-container {
    position: relative;
}

.textarea-with-ai-container {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.textarea-with-ai-container textarea {
    width: 100%;
    min-height: 120px;
    max-height: 300px;
    height: 120px;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    resize: vertical;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    overflow-y: auto;
}

.textarea-with-ai-container textarea:focus {
    outline: none;
    border-color: #4CAF50;
    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
}

.textarea-with-ai-container textarea.has-error {
    border-color: #f44336;
}

.btn-generate-ai {
    align-self: flex-start;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.btn-generate-ai:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-generate-ai:active:not(:disabled) {
    transform: translateY(0);
}

.btn-generate-ai:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-generate-ai i.fa-magic {
    animation: sparkle 2s ease-in-out infinite;
}

.btn-generate-ai i.fa-spinner {
    animation: spin 1s linear infinite;
}

@keyframes sparkle {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.6; }
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

@media only screen and (max-width: 767px) {
    .btn-generate-ai {
        align-self: stretch;
        justify-content: center;
    }
    
    .textarea-with-ai-container {
        gap: 10px;
    }
    
    .bio-field-container .field-help-text {
        font-size: 13px;
    }
}

/* SMS Validation Alert Styles */
.sms-validation-alert {
    border-left: 4px solid #f0ad4e;
    background-color: #fcf8e3;
    margin-bottom: 20px;
}

.sms-validation-alert .alert-icon {
    font-size: 24px;
    color: #f0ad4e;
    margin-right: 15px;
}

.sms-validation-alert .requirements-list {
    margin: 10px 0 0 0;
    padding-left: 0;
    list-style: none;
}

.sms-validation-alert .requirements-list li {
    padding: 5px 0;
    color: #666;
}

.sms-validation-alert .requirements-list li.completed {
    color: #5cb85c;
    font-weight: 500;
}

.sms-validation-alert .requirements-list li i {
    margin-right: 8px;
    min-width: 16px;
    display: inline-block;
}

.sms-validation-alert .requirements-list li.completed i {
    color: #5cb85c;
}

/* Amélioration de l'espacement pour les colonnes côte à côte */
@media only screen and (min-width: 768px) {
    .update-profile-component .form .row > [class*="col-md-12"] {
        padding-left: 15px;
        padding-right: 15px;
    }
    
    .update-profile-component .form .row {
        margin-left: -15px;
        margin-right: -15px;
        margin-bottom: 0;
    }
    
    /* Réduction de l'espace vertical entre les groupes de champs */
    .update-profile-component .form .row + .row {
        margin-top: 0;
    }
}

/* Sur mobile, conserver l'espacement normal */
@media only screen and (max-width: 767px) {
    .update-profile-component .form .row > [class*="col-"] {
        padding-left: 0;
        padding-right: 0;
    }
}
</style>

